import AutorenewIcon from '@material-ui/icons/Autorenew';

import List from './List2';

export default {
  list: List,
  icon: AutorenewIcon,
};
